import { HeaderTabType } from '../enums';
import { Tab } from '../components/layout/HeaderTabs';

export const TABS: Tab[] = [
    { title: 'Easy Selection SENTRON', to: '/', type: HeaderTabType.Selector }
];
